import { __assign, __makeTemplateObject } from "tslib";
import { IconButton as MuiIconButton, styled } from '@mui/material';
import { alpha } from '@mui/system';
import { CircularProgress } from '@components';
export var Children = styled('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Spinner = styled(CircularProgress)(function () { return ({
    position: "absolute",
}); });
var colorUndefinedMixIn = function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (__assign(__assign(__assign({ color: theme.palette.greySecondary.main, '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
        }, '&:active': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.16),
        }, '&:disabled': {
            color: alpha(theme.palette.greySecondary.main, 0.7),
            borderColor: alpha(theme.palette.greySecondary[300], 0.35),
        } }, (variant === 'contained' && {
        backgroundColor: theme.palette.greySecondary.main,
        color: theme.palette.greySecondary.contrastText,
        '&:hover, &:active': {
            opacity: 1,
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.32)",
        },
        '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.88),
        },
        '&:active': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.84),
        },
        '&:disabled': {
            color: alpha(theme.palette.greySecondary.contrastText, 0.9),
            borderColor: alpha(theme.palette.greySecondary.main, 0.35),
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.35),
        },
    })), (variant === 'outlined' && {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: theme.palette.greySecondary[300],
        color: theme.palette.greySecondary.main,
    })), (variant === 'dashed' && {
        borderWidth: "1px",
        borderStyle: "dashed",
        borderColor: theme.palette.greySecondary[600],
        backgroundColor: theme.palette.greySecondary[50],
        '&:hover': {
            backgroundColor: theme.palette.greySecondary.main,
            borderColor: theme.palette.greySecondary.main,
            '.MuiSvgIcon-root': {
                color: theme.palette.greySecondary.contrastText,
            },
        },
    })));
};
var colorInheritMixIn = function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (__assign(__assign(__assign({ color: 'inherit', '&:hover': {
            backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
            // backgroundColor: alpha(theme.palette.secondary.main, 0.08),
        }, '&:active': {
            backgroundColor: "color-mix(in srgb, currentColor 16%, transparent)",
            // backgroundColor: alpha(theme.palette.secondary.main, 0.16),
        }, '&:disabled, &.Mui-disabled': {
            color: 'inherit',
            opacity: 0.48,
        } }, (variant === 'contained' && {
        backgroundColor: 'currentColor',
        '&:hover, &:active': {
            backgroundColor: 'currentColor',
        },
        '&:disabled': {
            backgroundColor: "color-mix(in srgb, currentColor 35%, transparent)",
        },
    })), (variant === 'outlined' && {
        borderWidth: "1px",
        borderStyle: "solid",
    })), (variant === 'dashed' && {
        borderWidth: "1px",
        borderStyle: "dashed",
    })));
};
var variantMixIn = function (_a) {
    var theme = _a.theme, variant = _a.variant, color = _a.color;
    return (__assign(__assign(__assign({}, (variant === 'contained' && {
        color: theme.palette[color].contrastText,
        borderColor: theme.palette[color].main,
        backgroundColor: theme.palette[color].main,
        '&:hover, &:active': {
            opacity: 1,
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.32)",
        },
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, 0.88),
        },
        '&:active': {
            backgroundColor: alpha(theme.palette[color].main, 0.84),
        },
        '&:disabled': {
            color: alpha(theme.palette[color].contrastText, 0.9),
            borderColor: alpha(theme.palette[color].main, 0.35),
            backgroundColor: alpha(theme.palette[color].main, 0.35),
        },
    })), (variant === 'outlined' && {
        border: "1px solid",
        color: theme.palette[color].main,
        borderColor: theme.palette[color][300],
        backgroundColor: theme.palette[color].contrastText,
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, 0.08),
        },
        '&:active': {
            backgroundColor: alpha(theme.palette[color].main, 0.16),
        },
        '&:disabled': {
            color: alpha(theme.palette[color].main, 0.7),
            borderColor: alpha(theme.palette[color][300], 0.35),
        },
    })), (variant === 'dashed' && {
        border: "1px dashed ".concat(theme.palette[color][600]),
        backgroundColor: theme.palette[color][50],
        '.MuiSvgIcon-root': {
            color: theme.palette[color].main,
            transition: "all linear 0.2s",
        },
        '&:hover': {
            backgroundColor: theme.palette[color].main,
            borderColor: theme.palette[color].main,
            '.MuiSvgIcon-root': {
                color: theme.palette[color].contrastText,
            },
        },
        '&:disabled': {
            borderColor: alpha(theme.palette[color][600], 0.35),
            '.MuiSvgIcon-root': {
                color: alpha(theme.palette[color].main, 0.7),
            },
        },
    })));
};
var variantUndefinedMixIn = function (_a) {
    var theme = _a.theme, color = _a.color;
    return (__assign({ '&:disabled': {
            opacity: 0.48,
        } }, (color === 'inherit'
        ? {
            color: 'inherit',
            '&:hover': {
                backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
                // backgroundColor: alpha(theme.palette.white.main, 0.08)
            },
            '&:active': {
                backgroundColor: "color-mix(in srgb, currentColor 16%, transparent)",
                // backgroundColor: alpha(theme.palette.white.main, 0.16)
            },
        }
        : color === undefined
            ? {
                backgroundColor: "transparent",
                '&:hover': {
                    backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                },
                '&:active': {
                    backgroundColor: alpha(theme.palette.greySecondary.main, 0.16),
                },
            }
            : {
                color: theme.palette[color].main,
                '&:hover': {
                    backgroundColor: alpha(theme.palette[color].main, 0.08),
                },
                '&:active': {
                    backgroundColor: alpha(theme.palette[color].main, 0.16),
                },
            })));
};
export var StyledIconButton = styled(MuiIconButton, {
    shouldForwardProp: function (prop) {
        return !['variant', 'color', 'loading', 'circled'].includes(String(prop));
    },
})(function (_a) {
    var theme = _a.theme, variant = _a.variant, color = _a.color, loading = _a.loading, circled = _a.circled;
    return (__assign(__assign(__assign(__assign(__assign(__assign(__assign({ borderRadius: theme.shape.borderRadius }, (color === "inherit" && colorInheritMixIn({ theme: theme, variant: variant }))), (color === undefined && colorUndefinedMixIn({ theme: theme, variant: variant }))), (variant !== undefined &&
        color !== undefined &&
        color !== 'inherit' &&
        variantMixIn({ theme: theme, variant: variant, color: color }))), (variant === undefined && variantUndefinedMixIn({ theme: theme, color: color }))), (loading && {
        pointerEvents: "none",
        '> svg': {
            opacity: 0,
        },
    })), (circled && {
        borderRadius: "100%",
    })), { '&&': {
            '@media (hover: none)': __assign(__assign(__assign(__assign({}, (color === "inherit" && __assign(__assign(__assign({ backgroundColor: "transparent" }, (variant === 'contained' && {
                backgroundColor: 'currentColor'
            })), (variant === 'outlined' && {
                backgroundColor: "transparent"
            })), (variant === 'dashed' && {
                backgroundColor: "transparent"
            })))), (color === undefined && {
                '&:hover': __assign(__assign(__assign({ backgroundColor: "transparent" }, (variant === 'contained' && {
                    backgroundColor: theme.palette.greySecondary.main,
                    color: theme.palette.greySecondary.contrastText,
                    boxShadow: "none"
                })), (variant === 'outlined' && {
                    borderColor: theme.palette.greySecondary[300],
                    color: theme.palette.greySecondary.main,
                })), (variant === 'dashed' && {
                    borderColor: theme.palette.greySecondary[600],
                    backgroundColor: theme.palette.greySecondary[50],
                    '.MuiSvgIcon-root': {
                        color: theme.palette.greySecondary.main,
                    },
                }))
            })), (variant !== undefined && color !== undefined && color !== 'inherit' && __assign(__assign(__assign({}, (variant === 'contained' && {
                backgroundColor: theme.palette[color].main,
                boxShadow: "none"
            })), (variant === 'outlined' && {
                backgroundColor: theme.palette[color].contrastText,
            })), (variant === 'dashed' && {
                border: "1px dashed ".concat(theme.palette[color][600]),
                backgroundColor: theme.palette[color][50],
                '.MuiSvgIcon-root': {
                    color: theme.palette[color].main,
                },
            })))), (variant === undefined && {
                '&:hover': {
                    backgroundColor: "transparent"
                }
            }))
        } }));
});
var templateObject_1;
//# sourceMappingURL=styled.js.map